import type { ReactNode } from 'react'
import { Link } from 'react-router'
import logo from '../assets/logo.png'
import { hoofdnavigatie } from '../routes'

/*
 * De footer uit legacy/current. De bestaande site kent twee varianten: de
 * volledige footer op de vier hoofdpagina's, en een compacte regel op de
 * privacy- en bedanktpagina. Allebei overgenomen.
 */
export default function Footer({
  variant = 'volledig',
  onderRechts,
}: {
  variant?: 'volledig' | 'compact'
  /** Rechterhelft van de onderste regel; alleen bij de compacte variant. */
  onderRechts?: ReactNode
}) {
  if (variant === 'compact') {
    return (
      <footer className="footer">
        <div className="wrap">
          <div
            className="footer__bottom"
            style={{ borderTop: 0, paddingTop: 0 }}
          >
            <span>© 2026 GPKeuringen. Alle rechten voorbehouden.</span>
            <span>{onderRechts ?? 'KvK: 42122048'}</span>
          </div>
        </div>
      </footer>
    )
  }

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer__grid">
          <div>
            <Link className="brand" to="/" aria-label="GPKeuringen">
              <span className="brand__mark" aria-hidden="true">
                <img src={logo} alt="" />
              </span>
              <span className="brand__text">
                <span className="brand__name">GPKeuringen</span>
              </span>
            </Link>
            <p className="footer__about">
              Onafhankelijk sociaal-medisch adviesbureau. BIG-geregistreerde
              artsen, multidisciplinair team.
            </p>
          </div>
          <div>
            <h2>Pagina&apos;s</h2>
            <ul>
              {hoofdnavigatie.map((route) => (
                <li key={route.pad}>
                  <Link to={route.pad}>{route.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2>Contact</h2>
            <ul>
              <li>
                <a href="mailto:info@gpkeuringen.nl">info@gpkeuringen.nl</a>
              </li>
              <li>KvK: 42122048</li>
              <li>
                <Link to="/privacy">Privacyverklaring</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© 2026 GPKeuringen. Alle rechten voorbehouden.</span>
          <span>Gegevens verwerkt conform de AVG · Geen tracking-cookies</span>
        </div>
      </div>
    </footer>
  )
}
